import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NotificationDTO } from 'src/app/models/NotificationDTO.model';
import { NotificationService } from 'src/app/services/notification.service';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
@Component({
    selector: 'app-create-notification',
    templateUrl: './create-notification.component.html',
    styleUrl: './create-notification.component.css',
    imports: [CommonModule, FormsModule, CKEditorModule]
})
export class CreateNotificationComponent {

  information: string = 'Notifications';
  htmlContent?: string = '';
  sanitizedHtmlContent: SafeHtml = {} as SafeHtml;
  notificationDTO: NotificationDTO = {} as  NotificationDTO
  alert: Alert = {} as Alert;
  status?: number =  0;
  originalStatus? : number = 0;
  public Editor = ClassicEditor;
  public editorConfig = {
    toolbar: [
      'heading', '|',
      'bold', 'italic', 'underline', '|',
      'fontColor', 'fontBackgroundColor', 'fontSize', 'fontFamily', '|',
      'link', 'bulletedList', 'numberedList', 'alignment', '|',
      'undo', 'redo'
    ],
    fontSize: {
      options: ['tiny', 'small', 'default', 'big', 'huge', '18px', '24px', '36px', '48px']
    },
    fontColor: {
      columns: 5,
      colors: [
        { color: '#FF5733', label: 'Orange' },
        { color: '#C70039', label: 'Red' },
        { color: '#28B463', label: 'Green' },
        { color: '#2E86C1', label: 'Blue' },
        { color: '#581845', label: 'Purple' }
      ]
    },
    fontFamily: {
      options: [
        'default',
        'Arial, Helvetica, sans-serif',
        'Courier New, Courier, monospace',
        'Georgia, serif',
        'Lucida Sans Unicode, Lucida Grande, sans-serif',
        'Tahoma, Geneva, sans-serif',
        'Times New Roman, Times, serif',
        'Verdana, Geneva, sans-serif'
      ]
    }
  };

  constructor(
    public permissionsService: ValidatePermissionsService,
    private notificationService: NotificationService,
    private alertService: AlertService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.Notifications);

    this.notificationService.getNotification().subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.handleGetNotification(Data);
        } else {
          this.handleError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
      }
    );
  }

  handleGetNotification(notification: NotificationDTO){
    this.htmlContent = notification.htmlContent ?? '';
    this.sanitizedHtmlContent = this.sanitizeHtml(this.htmlContent);
    this.status = notification.status;
    this.originalStatus = notification.status;
  }

  sanitizeHtml(content: string): SafeHtml {
    // Transformar etiquetas <font> a <span> con estilos en línea
    const transformedContent = content
    return this.sanitizer.bypassSecurityTrustHtml(transformedContent);
  }

  createNotification(confirmed: boolean) {
    if(confirmed)
    {
      this.notificationDTO.htmlContent = this.htmlContent;
      this.notificationDTO.status = this.status;
      this.notificationService.createNotification(this.notificationDTO).subscribe(
        ({ StatusCode, Message, Data }) =>
          Data != null
            ? this.handleSaveSuccess(Data)
            : this.handleError(StatusCode),
        (error) => {
  
        }
      );
    }
    else
    {
        this.status = this.originalStatus;      
    }
  }

  handleError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  async handleSaveSuccess(notification: NotificationDTO) {
		this.alert = {
      alertMessage: 'Notification updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    //localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
    location.reload();
  }

  toggleStatus(event: any) {
    this.status = event.target.checked ? 1 : 0;
  }
}
